import React from 'react';
import PropTypes from 'prop-types';

import MartyLink from 'components/common/MartyLink';
import css from 'styles/components/account/disclaimers.scss';
import marketplace from 'cfg/marketplace.json';

const { domain, account: { cltLink } } = marketplace;

export const ChangeDisclaimer = (props, { testId }) => (
  <div className={css.changeDisclaimer} data-test-id={testId('changeDisclaimer')}>
    Please note that any changes you make now will not affect orders that you have already placed.  If you have a question about the shipping address of a past order, please contact the
    <MartyLink to={cltLink}><span className={css.cltLink}> {domain}</span>.com Customer Loyalty Team</MartyLink>.
  </div>
);

ChangeDisclaimer.contextTypes = {
  testId: PropTypes.func
};

export const ShippingDisclaimer = (props, { testId }) => (
  <div className={css.shippingDisclaimer} data-test-id={testId('shippingDisclaimer')}>
    <h4>United States Shipping</h4>
    <div>Products can be shipped to all US States, Territories, and Military addresses. Most orders are shipped via UPS (United Parcel Service). FedEx may also be used, as needed. All packages going to Alaska, Hawaii, P.O. Boxes, military addresses (APO, FPO), or US territories (i.e. Guam, Puerto Rico) will be sent via USPS and do not qualify for 1-Business Day shipping.</div>
  </div>
);

ShippingDisclaimer.contextTypes = {
  testId: PropTypes.func
};
